import * as THREE from 'three';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useBounds } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useDispatch, useSelector } from 'react-redux';
import TWEEN from "@tweenjs/tween.js";

import { captureBlobImages, isAllCaptured } from '../../../action/extra_options/orderExtras.action';
import { updateDoorWindowsArray } from '../../../action';
import * as actionCreator from '../../../action/index';
import { const_var , params} from '../../../redux/reducers/reducer';
import { TsCeSot } from '../../../redux/reducers/building_component/componentReducer';
import { extrudeSettings } from '../../../utils/Functions';

import Walls from './Walls';
import Storage from './Storage';
import Roof from './Roof';
import InstallationSurface from './Installation_surface';
import Watermark from './Watermark'
import DoorWindows from '../DoorWindows';
import Truss from './Truss';
import Measurements from '../Measurements';
import Cupolas from '../Cupolas';

const CenterBuilding = () => {
    const dispatch = useDispatch();
    const ref = useRef();
    const api = useBounds();
    const {scene} = useThree()


    useEffect(() => {   

        let obj= scene.getObjectByName("fullBuilding")

        if(const_var.imageObj != undefined){
            api.refresh(obj)
            const d = 25 * 5;
            const x = params.p_d/10;

            let i = 0;
            const oldControlDistance = const_var.controls.maxDistance;
            const_var.controls.maxDistance = 1400;
            const recursive = () => {
                const camera = const_var.camera;
                const controls = const_var.controls;

                if(i>3) {
                    const_var.controls.maxDistance = oldControlDistance;
                    dispatch(isAllCaptured(true))
                    const_var.activeTab = "buildingtypetab"
                    TsCeSot(const_var.imageObj.val,const_var.imageObj.chkIndex,true);
                    i = 0;
                    return;
                }

                let front = scene.getObjectByName("frontFocusSection")
                let back = scene.getObjectByName("backFocusSection")
                let left = scene.getObjectByName("leftFocusSection")
                let right = scene.getObjectByName("rightFocusSection")
                if(front != undefined) scene.remove(front)
                if(back != undefined) scene.remove(back)
                if(left != undefined) scene.remove(left)
                if(right != undefined) scene.remove(right)

                let obj= scene.getObjectByName("fullBuilding")
                api.refresh(obj)
                let building = api.refresh(obj).getSize()
                
                let minX = (isNaN(building.box.min.x)) ? (params.add_left_lean) ? -params.p_w/2 - (params.leanStyle.left === 'standard' ? params.lean_p_w : params.lean_p_d) : -params.p_w/2 : building.box.min.x;
                let minY = (isNaN(building.box.min.y)) ? 0 : building.box.min.y;
                let minZ = (isNaN(building.box.min.z)) ? (params.add_back_lean) ? -params.p_d/2 - (params.leanStyle.back === 'standard' ? params.leanB_p_w : params.leanB_p_d) : -params.p_d/2 : building.box.min.z;
                let maxX = (isNaN(building.box.max.x)) ? (params.add_right_lean) ? params.p_w/2 + (params.leanStyle.right === 'standard' ? params.leanR_p_w : params.leanR_p_d) : params.p_w/2 : building.box.max.x;
                let maxY = (isNaN(building.box.max.y)) ? params.p_h + ((params.p_w/2) * (params.p_r_p/12)) : building.box.max.y;
                let maxZ = (isNaN(building.box.max.z)) ? (params.add_front_lean) ? params.p_d/2 + (params.leanStyle.front === 'standard' ? params.leanF_p_w : params.leanF_p_d) : params.p_d/2 : building.box.max.z;

                const frontFocusSectionModel = new THREE.Shape();
                frontFocusSectionModel.moveTo(minX - x, minY );
                frontFocusSectionModel.lineTo(minX - x, maxY);
                frontFocusSectionModel.lineTo(maxX + x, maxY);
                frontFocusSectionModel.lineTo(maxX + x, minY);
                frontFocusSectionModel.closePath();

                const backFocusSectionModel = new THREE.Shape();
                backFocusSectionModel.moveTo(minX, minY );
                backFocusSectionModel.lineTo(minX, maxY);
                backFocusSectionModel.lineTo(maxX, maxY);
                backFocusSectionModel.lineTo(maxX, minY);
                backFocusSectionModel.closePath();

                const leftFocusSectionModel = new THREE.Shape();
                leftFocusSectionModel.moveTo(minZ, minY );
                leftFocusSectionModel.lineTo(minZ, maxY);
                leftFocusSectionModel.lineTo(maxZ, maxY);
                leftFocusSectionModel.lineTo(maxZ, minY);
                leftFocusSectionModel.closePath();

                const rightFocusSectionModel = new THREE.Shape();
                rightFocusSectionModel.moveTo(minZ, minY );
                rightFocusSectionModel.lineTo(minZ, maxY);
                rightFocusSectionModel.lineTo(maxZ, maxY);
                rightFocusSectionModel.lineTo(maxZ, minY);
                rightFocusSectionModel.closePath();

                let frontFocusSection = new THREE.Mesh(new THREE.ExtrudeGeometry(frontFocusSectionModel, extrudeSettings(0.3)))
                frontFocusSection.position.z = maxZ
                frontFocusSection.name = "frontFocusSection"
                frontFocusSection.visible = false
                if(scene.getObjectByName("frontFocusSection") == undefined) scene.add(frontFocusSection)

                let backFocusSection = new THREE.Mesh(new THREE.ExtrudeGeometry(backFocusSectionModel, extrudeSettings(0.3)))
                backFocusSection.position.z = minZ
                backFocusSection.rotation.y = 0
                backFocusSection.name = "backFocusSection"
                backFocusSection.visible = false
                if(scene.getObjectByName("backFocusSection") == undefined) scene.add(backFocusSection)

                let leftFocusSection = new THREE.Mesh(new THREE.ExtrudeGeometry(leftFocusSectionModel, extrudeSettings(0.3)))
                leftFocusSection.position.x = minX
                leftFocusSection.rotation.y = Math.PI/-2
                leftFocusSection.name = "leftFocusSection"
                leftFocusSection.visible = false
                if(scene.getObjectByName("leftFocusSection") == undefined) scene.add(leftFocusSection)

                let rightFocusSection = new THREE.Mesh(new THREE.ExtrudeGeometry(rightFocusSectionModel, extrudeSettings(0.3)))
                rightFocusSection.position.x = maxX
                rightFocusSection.rotation.y = Math.PI/-2
                rightFocusSection.name = "rightFocusSection"
                rightFocusSection.visible = false
                if(scene.getObjectByName("rightFocusSection") == undefined) scene.add(rightFocusSection)


                let focusMesh = api.refresh(frontFocusSection).getSize()
                if(i==0){
                    focusMesh = api.refresh(frontFocusSection).getSize()
                }else if(i==1){
                    focusMesh = api.refresh(leftFocusSection).getSize()
                }else if(i==2){
                    focusMesh = api.refresh(backFocusSection).getSize()
                }else if(i==3){
                    focusMesh = api.refresh(rightFocusSection).getSize()
                }

                const positions = [
                    { x: params.p_w / 2 + (params.add_right_lean? (params.leanStyle.right === 'standard' ? params.leanR_p_w : params.leanR_p_d) : 0) + d /4 * 3, y: params.p_h / 2, z: focusMesh.box.max.z + focusMesh.distance },
                    { x: focusMesh.box.max.z + focusMesh.distance, y: params.p_h / 2, z: 0 },
                    { x: 0, y: params.p_h / 2, z: focusMesh.box.min.z -focusMesh.distance},
                    { x: focusMesh.box.min.z - focusMesh.distance, y: params.p_h / 2, z: 0 },
                ];
                
                const targetPosition = positions[i]
                new TWEEN.Tween(camera.position)
                .to(targetPosition, 300)
                .onUpdate(() => {
                    controls.target.set(0, params.p_h / 2, 0);
                    controls.update(); // Make sure controls are updated with the new camera position
                })
                .onComplete(() => {
                    dispatch(captureBlobImages());
                    i++
                    setTimeout(() => {
                        recursive()
                    }, 100);
                })
                .start();
           
            } 
            recursive()
        }
        

    },[JSON.stringify(const_var.imageObj),params.p_w,params.p_d])


    const mainTrussPosInfo = useSelector(state => state.reducer.mainTrussPosInfo);
    const leanToTrussPosInfo = useSelector(state => state.reducer.leanToTrussPosInfo);

    const [overlapTrussArr, setOverlapTrussArr] = useState([]);
    const [newDoorsArray, setNewDoorsArray] = useState(const_var.newDoorsArray)

    const prv_p_w = useMemo(() => {
        ref.current = params.p_w;
        const prv_p_w = ref.current
        
        return prv_p_w    
    }, [params.p_w])
    
    useEffect(() => {
        if (const_var.newDoorsArray.length > 0) {
            const legThickness = 0.24;
            const updatedDoorsArr = const_var.newDoorsArray.map((item, index)=> {
                let cutLegCount = 0;
                if (item.userData.wallName === 'c_b_r_w' || item.userData.wallName === 'c_b_l_s_r_w' || item.userData.wallName === 'c_b_r_s_w' || item.userData.wallName === 'L_L_R_S_W' ||
                    item.userData.wallName === 'c_b_l_w' || item.userData.wallName === 'c_b_r_s_l_w' || item.userData.wallName === 'c_b_l_s_w' || item.userData.wallName === 'R_L_L_S_W'
                ) {
                    if (mainTrussPosInfo?.length > 0) {
                        mainTrussPosInfo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    } 
                } else if (item.userData.wallName === 'F_L_F_W' || item.userData.wallName === 'F_L_F_S_W') {
                    if (leanToTrussPosInfo?.frontLeanTo?.length > 0) {
                        leanToTrussPosInfo.frontLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                } else if (item.userData.wallName === 'B_L_S_W' || item.userData.wallName === 'B_L_F_S_W') {
                    if (leanToTrussPosInfo?.backLeanTo?.length > 0) {                        
                        leanToTrussPosInfo.backLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                } else if (item.userData.wallName === 'R_L_R_W' ||  item.userData.wallName === 'R_L_R_S_W') {
                    if (leanToTrussPosInfo?.rightLeanTo?.length > 0) {                        
                        leanToTrussPosInfo.rightLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                } else if (item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W') {
                    if (leanToTrussPosInfo?.leftLeanTo?.length > 0) {                        
                        leanToTrussPosInfo.leftLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                }
                return {
                    ...item,
                    cutLegCount,
                }
            })

            if (JSON.stringify(updatedDoorsArr) !== JSON.stringify(const_var.newDoorsArray)) {
                setNewDoorsArray(updatedDoorsArr)
            }
        }
    }, [const_var.newDoorsArray, mainTrussPosInfo, leanToTrussPosInfo])
    
    useEffect(() => {
        dispatch(updateDoorWindowsArray(newDoorsArray));
    }, [newDoorsArray])    

    useMemo(() => {
        if(params.cB_addStorage_check_left){
            const_var.newDoorsArray.filter((e) => e.userData.wallName === "c_b_l_s_f_w" || e.userData.wallName === "c_b_l_s_b_w").map((item) => {
                let newPositionX;
                if(item.userData.wallName === 'c_b_l_s_f_w'){
                    newPositionX = item.positionX + (prv_p_w - params.p_w) / 2;
                }else {
                    newPositionX = item.positionX - (prv_p_w - params.p_w) / 2;
                }
               
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
            });
        } else if(params.cB_addStorage_check_right){
            const_var.newDoorsArray.filter((e) => e.userData.wallName === "c_b_r_s_f_w" || e.userData.wallName === "c_b_r_s_b_w").map((item) => {
                let newPositionX;
                if(item.userData.wallName === 'c_b_r_s_f_w'){
                    newPositionX = item.positionX - (prv_p_w - params.p_w) / 2;
                }else {
                    newPositionX = item.positionX + (prv_p_w - params.p_w) / 2;
                }
               
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
            }); 
        }

    }, [params.p_w, prv_p_w, params.cB_addStorage_check_left, params.cB_addStorage_check_right])
    
    return (
        <group name='center'>
            {(const_var.DistanceArr!=undefined && const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) && 
                <>
                    <Walls />
                    <Storage />
                    <Roof />
                    <InstallationSurface />
                    <Watermark/>
                    <DoorWindows overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} />
                    {(const_var.DistanceArr!=undefined && const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) && 
                        <Truss overlapTrussArr={overlapTrussArr} />
                    }
                    <group name='Measurements-main'>
                        <Measurements />
                    </group>
                    {const_var.cupolas.length > 0 && <Cupolas />}
                </>
            }
        </group>
    )
}

export default CenterBuilding